// @ts-expect-error Untyped module
import WarningsAndSuggestionsPanel from '../../modals/WarningsAndSuggestionsPanel';
import UnpublishConfirmModal from '../../modals/UnpublishConfirmModal';
import SchedulingOptionsModal from '../../publishing/modals/SchedulingOptionsModal';
import CancelScheduleConfirmModal from '../../publishing/modals/schedulingOptions/CancelScheduleConfirmModal';
import { PublishActionModalNames } from '../../publishing/types/publishButtonTypes';
import PublishConfirmModal from './PublishConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorPublishButtonActionModals = ({
  publishErrors,
  publishWarnings,
  onIssueClick,
  buttonTextKey,
  schedulingOptionsModalProps = {},
  setCancelScheduleModalType,
  cancelScheduleModalType,
  confirmPublishActionProps = {},
  publish,
  unpublish,
  schedulePublishUnpublish,
  openModalName,
  openModal,
  closeModal
}) => {
  switch (openModalName) {
    case PublishActionModalNames.PUBLISH_CONFIRM:
      return /*#__PURE__*/_jsx(PublishConfirmModal, {
        publishButtonTextKey: buttonTextKey,
        confirmPublishActionProps: confirmPublishActionProps,
        publish: publish,
        closeModal: closeModal
      });
    case PublishActionModalNames.UNPUBLISH_CONFIRM:
      return /*#__PURE__*/_jsx(UnpublishConfirmModal, {
        onClose: closeModal,
        unpublish: unpublish
      });
    case PublishActionModalNames.SCHEDULING_OPTIONS:
      return /*#__PURE__*/_jsx(SchedulingOptionsModal, Object.assign({
        publish: publish,
        schedulePublishUnpublish: schedulePublishUnpublish,
        closeModal: closeModal,
        openCancelScheduleConfirmModal: modalType => {
          setCancelScheduleModalType(modalType);
          openModal(PublishActionModalNames.CANCEL_SCHEDULE);
        }
      }, schedulingOptionsModalProps));
    case PublishActionModalNames.CANCEL_SCHEDULE:
      return /*#__PURE__*/_jsx(CancelScheduleConfirmModal, {
        closeModal: closeModal,
        actionTypeBodyInfoKey: cancelScheduleModalType,
        isScheduleUpdate: false,
        publish: publish
      });
    case PublishActionModalNames.WARNINGS_AND_SUGGESTIONS:
      return /*#__PURE__*/_jsx(WarningsAndSuggestionsPanel, {
        errorLabels: publishErrors,
        warningLabels: publishWarnings,
        onClose: closeModal,
        onIssueClick: (target, onClickData) => onIssueClick({
          target,
          onClickData
        })
      });
    default:
      return null;
  }
};
export default EditorPublishButtonActionModals;